import { MapPin } from "lucide-react";

// Ocho Rios Marina · 18.408366, -77.109702
const OCHO_RIOS_BBOX = "-77.165,18.380,-77.060,18.440";
const OCHO_RIOS_MARKER = "18.408366,-77.109702";

export default function Location() {
  return (
    <section id="location" data-testid="location-section" className="aq-section aq-bg-foam">
      <div className="aq-container grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <span className="aq-overline">Location</span>
          <h2 className="aq-h2 text-4xl sm:text-5xl mt-4" style={{ color: "var(--aq-navy)" }}>
            Departing Ocho Rios Marina.
          </h2>
          <span className="aq-divider" />
          <p className="text-base text-[15px] leading-relaxed" style={{ color: "var(--aq-text-soft)" }}>
            We run out of Ocho Rios Marina on Jamaica's north coast. The deep blue
            water drops off within minutes — we fish 5 to 8 miles offshore for marlin,
            yellowfin tuna, mahi mahi, wahoo and bonito.
          </p>
          <ul className="mt-6 space-y-3 text-[15px]" style={{ color: "var(--aq-text)" }}>
            <li className="flex items-start gap-3">
              <MapPin size={18} style={{ color: "var(--aq-gold)", marginTop: 3 }} />
              <span><strong>Marina</strong>: Ocho Rios Marina, Jamaica · 18.4084° N, 77.1097° W</span>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={18} style={{ color: "var(--aq-gold)", marginTop: 3 }} />
              <span><strong>Pickup</strong>: arranged at reservation — Ocho Rios marinas &amp; nearby resorts.</span>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={18} style={{ color: "var(--aq-gold)", marginTop: 3 }} />
              <span><strong>Fishing grounds</strong>: 5–8 miles offshore, deep-sea trolling.</span>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-7">
          <div className="aq-gallery-tile" style={{ aspectRatio: "16 / 11" }}>
            <iframe
              data-testid="location-map"
              title="Ocho Rios Marina map"
              src={`https://www.openstreetmap.org/export/embed.html?bbox=${OCHO_RIOS_BBOX}&layer=mapnik&marker=${OCHO_RIOS_MARKER}`}
              style={{ width: "100%", height: "100%", border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <p className="text-xs mt-3" style={{ color: "var(--aq-text-soft)" }}>
            Map: OpenStreetMap contributors.
          </p>
        </div>
      </div>
    </section>
  );
}
